import {
	FormControl,
	FormLabel,
	TextField as MuiTexField,
	type TextFieldProps,
	makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
	input: {
		background: '#fff',
		fontWeight: 500,
	},
	textField: {
		fontWeight: 500,
	},
}));

export const TextField = (props: TextFieldProps) => {
	const classes = useStyles();
	const { error, label, name, ...rest } = props;

	return (
		<FormControl error={error} fullWidth>
			{label && <FormLabel htmlFor={name}> {label} </FormLabel>}

			<MuiTexField
				helperText={error}
				{...rest}
				InputProps={{
					className: classes.input,
					...rest.InputProps,
				}}
				aria-describedby={`helper-text-${name}`}
				autoComplete={'off'}
				className={classes.textField}
				error={error}
				fullWidth
				id={name}
				name={name}
				variant={'outlined'}
			/>
		</FormControl>
	);
};
